export default __webpack_public_path__ + "4924e41169366a523f0b9a23d2fcc900.svg";